import { all, fork } from "redux-saga/effects";

//#region layout
import LayoutSaga from "./layouts/saga";
//#endregion

//#region auth
import AuthSaga from "./auth/login/saga";
import ForgetSaga from "./auth/forgetpwd/saga";
import resetPasswordSaga from "./auth/resetPassword/saga";
//#endregion

//#region profile
import ProfileSaga from "./auth/profile/saga";
//#endregion

//#region customers
import customersSaga from "./users/customers/saga";
//#endregion

//#region technicians
import techniciansSaga from "./users/technicians/saga";
//#endregion

//#region categories
import categoriesSaga from "./services/categories/saga";
//#endregion

//#region services
import servicesSaga from "./services/services/saga";
//#endregion

//#region governorate
import governorateSage from "./locations/governorates/saga";
//#endregion

//#region cities
import citiesSaga from "./locations/cities/saga";
//#endregion

//#region notifications
import notificationsSaga from "./notification/saga";
//#endregion

//#region ads
import adsSaga from "./ads/saga";
//#endregion

//#region complain
import complainsSaga from "./complains/saga";
//#endregion

//#region orders
import ordersSaga from "./orders/saga";
//#endregion

//#region policies
import policiesSaga from "./policies/saga";
//#endregion

//#region settings
import settingsSaga from "./settings/saga";
//#endregion

//#region dashboard
import dashboardSaga from "./dashboard/saga";
//#endregion

//#region subscriptions
import subscriptionsSaga from "./plans/subscriptions/saga";
//#endregion

export default function* rootSaga() {
  yield all([
    //public
    fork(LayoutSaga),
    fork(AuthSaga),
    fork(resetPasswordSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(customersSaga),
    fork(techniciansSaga),
    fork(categoriesSaga),
    fork(servicesSaga),
    fork(governorateSage),
    fork(citiesSaga),
    fork(notificationsSaga),
    fork(adsSaga),
    fork(complainsSaga),
    fork(ordersSaga),
    fork(policiesSaga),
    fork(settingsSaga),
    fork(dashboardSaga),
    fork(subscriptionsSaga),
  ]);
}
